import PropTypes from 'prop-types';

export const StorageArea = {
  id: PropTypes.string,
  name: PropTypes.string,
};

export default StorageArea;
